<template>
	<el-dialog class="custom-dialog tsodo-detail-dialog" append-to-body destroy-on-close :visible.sync="isPopupActiveLocal">
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">TẢI BÁO CÁO</h4>
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6" v-if="isPopupActiveLocal">

				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Từ ngày:
					</label>
					<CbsDatePicker value-format="yyyy-MM-dd" name="from_date" :data-vv-as="'Thời gian'" class="w-full" v-model="from_date" type="date" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
				</div>

				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Tới ngày:
					</label>
					<CbsDatePicker value-format="yyyy-MM-dd" name="to_date" :data-vv-as="'Thời gian'" class="w-full" v-model="to_date" type="date" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
				</div>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer" vs-justify="center">
			<vs-button class="vs-component vs-button font-bold mr-2" @click.stop="reportOrder(1)">Khớp Lệnh Mua Vào</vs-button>
			<vs-button class="vs-component vs-button font-bold mr-2" @click.stop="reportOrder(2)">Khớp Lệnh Bán Ra</vs-button>
			<!-- <vs-button class="vs-component vs-button font-bold ml-2" @click.stop="reportBilling(1)">Công Nợ Phải Trả</vs-button> -->
			<vs-button class="vs-component vs-button font-bold ml-2" @click.stop="reportBilling(3)">Công Nợ</vs-button>
		</div>
	</el-dialog>
</template>
<script>
// import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import Helpers from '../../../utils/helpers';

export default {
	name: "DialogAccountReport",
	components: { vSelect, SelectAssigned, CbsDatePicker },
	props: {
		seekingData: {
			type: Function,
			required: true
		},
		cachedCustomers: {
			type: Array,
		},
		isPopupActive: {
			type: Boolean,
			required: true
		},
		state: {

		},
	},
	data() {
		return {
			settings: {},
			pickerOptions: {},
			from_date: null,
			to_date: null,
		};
	},
	methods: {
		async reportBilling(type) {
			if (!this.from_date || !this.to_date) {
				this.$helper.notifyError({
					context: this,
					options: {
						text: "Chưa chọn từ ngày tới ngày",
					},
				});
				return;
			}
			let filters = {
				from_date: this.from_date,
				to_date: this.to_date,
				report_type: type
			};
			const payload = {
				// rtype: type,
				download2: 1,
				filters: filters,
				id: 0,
				allCompany: 1,
				report_type: type
			};
			try {
				let allData = await this.$store.dispatch("moduleProduct/getOrdersByMe", payload);
				console.log('allData: ', allData);
				if (allData) {
					window.location.href = allData;
				}
				
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async reportOrder(type) {
			if (!this.from_date || !this.to_date) {
				this.$helper.notifyError({
					context: this,
					options: {
						text: "Chưa chọn từ ngày tới ngày",
					},
				});
				return;
			}
			let filters = {
				from_date: this.from_date,
				to_date: this.to_date,
				types: [type]
			};
			const payload = {
				report_type: type,
				download: 1,
				filters: filters,
				id: 0,
				allCompany: 1
			};
			try {
				let allData = await this.$store.dispatch("moduleProduct/getOrdersByMe", payload);
				console.log('allData: ', allData);
				if (allData) {
					window.location.href = allData;
				}
				
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		seekingDataLocal(reset = false) {
			let filters = {};
			if (reset) {
				this.to_date = null;
				this.from_date = null;
			}
			filters = {
				from_date: this.from_date,
				to_date: this.to_date
			};
			let state = {
				from_date: this.from_date,
				to_date: this.to_date
			};
			this.seekingData(filters, state);
		},
	},
	watch: {
		// city() {
		// 	// this.district = null;
		// 	// this.customer = null;
		// 	this.getDistrictList();
		// 	this.getCustomers();
		// 	this.setCityName()
		// },
		// district() {
		// 	// this.customer = null;
		// 	this.getCustomers();
		// 	this.setDistrictName();
		// },
		// customer() {
		// 	this.setCustomerName();
		// }
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
	},
	created() {
		const {from_date, to_date} = this.state || {};
		this.from_date = from_date;
		this.to_date = to_date;
	}
	
};
</script>
